<script>

export default {
    name: 'OrganisationPage',
    mounted() {
        this.$store.dispatch('setSiteHeaderOpaque');
        this.$store.dispatch('showSiteFooter');
    },
    computed: {
        routerKey() {
            return this.$route.path;
        },
    },
};
</script>

<template>
    <section class="organisation-page">
        <div class="organisation-page__wrapper">
            <router-view v-bind:key="routerKey" />
        </div>
    </section>
</template>

<style lang="scss" scoped>
.organisation-page {
    @include page;
}
.organisation-page__wrapper {
    @include container-narrow;
}
.organisation-page__lead {
    font-size: 2.4rem;
    letter-spacing: 0.028rem;
    line-height: 1.54;

    @include breakpoint('sm-down') {
        ont-size: 2.24rem;
        line-height: 1.44;
    }
}
</style>
